"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const TableSummaryProposalsList_vue_1 = __importDefault(require("./TableSummaryProposalsList.vue"));
const ZeroMatchesSearch_vue_1 = __importDefault(require("./ZeroMatchesSearch.vue"));
const ZeroProposals_vue_1 = __importDefault(require("./ZeroProposals.vue"));
const TableProposals_vue_1 = __importDefault(require("./TableProposals.vue"));
const debounce_1 = require("@common/tsutils/debounce");
let ProposalListYield = class ProposalListYield extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.filteredProposals = [];
        this.filterVal = '';
        this.localLoading = false;
        this.criteria = '';
        this.direction = 0;
    }
    loadProposal(p, proposal) {
        this.$emit('loadproposaldetail', p, proposal);
    }
    switchToResults(payload) {
        this.$emit('switchToResults', payload);
    }
    get minProposalIxHumanized() {
        const pageLength = this.itemsPerPage;
        return pageLength * (this.currentPage - 1) + 1;
    }
    get maxProposalIxHumanized() {
        const pageLength = this.itemsPerPage;
        const initialNumber = pageLength * (this.currentPage - 1) + 1;
        return initialNumber + this.proposals.length - 1;
    }
    get hasProposals() {
        if (this.totalProposals > 0 || this.filterVal.length > 0)
            return true;
        return false;
    }
    get numOngoingProposals() {
        let numOngoing = 0;
        if (this.filteredProposals.length) {
            numOngoing = this.filteredProposals.filter((prop) => { var _a; return ((_a = prop.status) === null || _a === void 0 ? void 0 : _a.slug) !== 'completed'; }).length;
        }
        return numOngoing;
    }
    preFilterProposalsServer(s) {
        this.localLoading = true;
        this.filterProposalsServer(s);
        setTimeout(() => (this.localLoading = false), 1000);
    }
    filterProposalsServer(s) {
        this.filterVal = s;
        this.$emit('filterproposalssserver', 1, s);
    }
    updateSortable(newCriteria) {
        const directions = [-1, 0, 1];
        if (newCriteria !== this.criteria) {
            this.criteria = newCriteria;
            this.direction = directions[2];
        }
        else {
            let dirIx = directions.findIndex((d) => d === this.direction);
            dirIx === directions.length - 1 ? (dirIx = 0) : (dirIx = dirIx + 1);
            this.direction = directions[dirIx];
        }
        this.$emit('updateSortableProposals', newCriteria, this.direction);
    }
    loadPage(num) {
        this.$emit('loadpage', num);
    }
    mounted() {
        this.filteredProposals = this.proposals;
    }
    created() {
        this.filteredProposals = this.proposals;
    }
    updated() {
        this.filteredProposals = this.proposals;
    }
    filterByStatusParam() {
        this.filterProposalsServer(this.statusParam);
    }
    launchCrumb(name) {
        this.$emit('launchcrumb', name);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], ProposalListYield.prototype, "proposals", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], ProposalListYield.prototype, "totalPages", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], ProposalListYield.prototype, "itemsPerPage", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], ProposalListYield.prototype, "totalProposals", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], ProposalListYield.prototype, "currentPage", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ProposalListYield.prototype, "isAllDownloaded", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], ProposalListYield.prototype, "statusParam", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ProposalListYield.prototype, "loadingProposals", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ProposalListYield.prototype, "loadingView", void 0);
__decorate([
    (0, debounce_1.Debounce)(1000)
], ProposalListYield.prototype, "filterProposalsServer", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('statusParam')
], ProposalListYield.prototype, "filterByStatusParam", null);
ProposalListYield = __decorate([
    (0, vue_property_decorator_1.Options)({
        emits: ['loadproposaldetail', 'switchToResults', 'filterproposalssserver', 'updateSortableProposals', 'loadpage', 'launchcrumb'],
        components: {
            PageHeading: bmk_ui_framework_1.PageHeading,
            Yield: bmk_ui_framework_1.Yield,
            Breadcrumbs: bmk_ui_framework_1.Breadcrumbs,
            BreadcrumbsItem: bmk_ui_framework_1.BreadcrumbsItem,
            HomeIcon: bmk_ui_framework_1.HomeIcon,
            ProposalsIcon: bmk_ui_framework_1.ProposalsIcon,
            TableSummaryProposalsList: TableSummaryProposalsList_vue_1.default,
            TableProposals: TableProposals_vue_1.default,
            Separator: bmk_ui_framework_1.Separator,
            Pagination: bmk_ui_framework_1.Pagination,
            ZeroMatchesSearch: ZeroMatchesSearch_vue_1.default,
            ZeroProposals: ZeroProposals_vue_1.default,
            Loader: bmk_ui_framework_1.Loader,
            Loading: bmk_ui_framework_1.Loading,
        },
    })
], ProposalListYield);
exports.default = ProposalListYield;
